const chimeraEndpoint = process.env.NEXT_PUBLIC_CHIMERA_ENDPOINT;
const accountsEndpoint = process.env.NEXT_PUBLIC_ACCOUNTS_ENDPOINT;
const lapURL = process.env.NEXT_PUBLIC_LAP_URL;
const privacyPolicyURL = process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL;
const hygraphEndpoint = process.env.NEXT_PUBLIC_HYGRAPH_PROJECT_API;
const sentryDNS = process.env.NEXT_PUBLIC_SENTRY_DSN;
const paperxEndpoint = process.env.NEXT_PUBLIC_PAPERX_ENDPOINT;
const dexSchemaStitchingEndpoint = process.env.NEXT_PUBLIC_DEX_SCHEMA_STITCHING_ENDPOINT;
const dexAuthEndpoint = process.env.NEXT_PUBLIC_DEX_AUTH_ENDPOINT;
const pegasusEponaEndpoint = process.env.NEXT_PUBLIC_PEGASUS_EPONA_ENDPOINT;
const pegasusPepeLegalUndergradEndpoint =
  process.env.NEXT_PUBLIC_PEGASUS_PEPE_LEGAL_UNDERGRAD_ENDPOINT;
const supportMaterialsURL = process.env.NEXT_PUBLIC_SUPPORT_MATERIALS_URL;
const ugFrontendEndpoint = process.env.NEXT_PUBLIC_UG_FRONTEND_ENDPOINT;
const ugBackendEndpoint = process.env.NEXT_PUBLIC_UG_BACKEND_ENDPOINT;
const ugEnrollmentsGraphqlEndpoint = process.env.NEXT_PUBLIC_UG_ENROLLMENTS_GRAPHQL_HTTP;

const westerosGraphqlURL = {
  MAMATA_ENDPOINT: process.env.NEXT_PUBLIC_WESTEROS_MAMATA,
  MAMATA_PROFILE: process.env.NEXT_PUBLIC_UG_PROFILE,
  UNDERGRAD_FORUM: process.env.NEXT_PUBLIC_WESTEROS_UNDERGRAD_FORUM,
};

export const ENDPOINTS = {
  chimera: chimeraEndpoint,
  accounts: accountsEndpoint,
  lap: lapURL,
  privacyPolicy: privacyPolicyURL,
  hygraph: hygraphEndpoint,
  sentry: sentryDNS,
  paperx: paperxEndpoint,
  dexAPI: dexSchemaStitchingEndpoint,
  dexAuth: dexAuthEndpoint,
  westerosGraphql: westerosGraphqlURL,
  pegasusEponaEndpoint: pegasusEponaEndpoint,
  pegasusPepeLegalUndergradEndpoint: pegasusPepeLegalUndergradEndpoint,
  supportMaterials: supportMaterialsURL,
  ugFrontend: ugFrontendEndpoint,
  ugBackend: ugBackendEndpoint,
  ugEnrollmentsGraphql: ugEnrollmentsGraphqlEndpoint,
};
